export default "__VITE_ASSET__DG2k7rga__"